import { Collapse, Spin } from "antd";
import {
    DownOutlined, SearchOutlined, UserOutlined, LoadingOutlined, MailOutlined, EditOutlined, MinusCircleOutlined, CheckCircleOutlined,
    SettingOutlined
} from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import './searchSelect.css'
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import { classNames } from "primereact/utils";
import { Button } from 'antd';
import { Button as MaterialBtn } from '@mui/material';
import { Confirmation } from "schemas";
import { useRecoilState } from "recoil";


function useDebounce(value, delay) {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebounced(value);
        }, delay);

        return () => clearTimeout(handler);
    }, [value, delay]);

    return debounced;
}

function useClickOutside(ref, callback) {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!ref.current) return;

            if (!ref.current.contains(event.target)) {
                callback();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, callback]);
}

export default function NewSearchSelect({ open, setOpen }) {
    const searchRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [list, setList] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const { fetchData, loading } = GeneralFetch()
    const [confirmation, setOpenConfirm] = useRecoilState(Confirmation)
    const ref = useRef(null)

    useClickOutside(searchRef, () => {
        setShowResults(false);
        setOpen(null)
    });

    const handleAgenteSelect = (agente) => {
        const estado = agente?.activo == 1 ? 0 : 1
        ref.current = { id: agente?.id, estado }
        const msg = `Tem certeza que deseja ${estado == 0 ? 'bloquear' : 'desbloquear'} o acesso do Sr(a). ${agente?.name}?`
        setOpenConfirm({ component: "blockUser", open: true, msg })
    };


    useEffect(() => {
        const fetchDataAsync = async () => fetchData(
            '',
            'activoUpdate/' + ref.current?.id + '?estado=' + ref.current?.estado,
            'put',
            ''
        )

        if (confirmation.confirmed == true && confirmation?.component == "blockUser") {
            setOpen(false)
            void fetchDataAsync().then(() => {
                setOpenConfirm({})
                ref.current = null
            })
        }
    }, [confirmation.confirmed])

    const debouncedFilter = useDebounce(searchTerm, 300);

    useEffect(() => {
        const fetchDataAsync = async () => {
            await fetchData('', `search/${debouncedFilter}`, 'get', 'users').then((resp) => {
                setList(resp?.users)
            })
        }

        if (debouncedFilter) void fetchDataAsync();
    }, [debouncedFilter])

    return (
        <>
            <MaterialBtn
                onClick={() => {
                    setOpen(prev => !prev)
                }}
                size="medium"
                variant="contained"
                style={{
                    color: "#fff",
                    textTransform: "capitalize",
                    fontSize: "14px", letterSpacing: "1px", background: "#ff4a4aff",
                    width: "320px"
                }}
                startIcon={(loading && ref.current != null) ? <LoadingOutlined style={{ fontSize: 20 }} spin /> : <SettingOutlined />}
                disabled={loading && ref.current != null}
            >
                {loading && ref.current != null ? "A actualizar acesso..." : "Actualizar estados de utilizadores"}
            </MaterialBtn>
            <Collapse
                collapsible="header"
                ghost={true}
                activeKey={open?.toString()}
                items={[
                    {
                        key: 'true',
                        children: <div className="search-select-container" ref={searchRef}>
                            <div className="search-input-wrapper">
                                <SearchOutlined className="search-icon" />
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    onFocus={() => { setShowResults(true) }}
                                    placeholder="Pesquise um utilizador (nome, código, email)"
                                    className="search-input"
                                    required
                                />
                                <DownOutlined className="chevron-icon" />
                            </div>

                            {showResults &&
                                <div className="results-dropdown">
                                    {loading ?
                                        <div className="empty-state">
                                            <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
                                        </div> :
                                        (!list || list?.length == 0) ? (
                                            <div className="empty-state">
                                                Nenhum utilizador encontrado
                                            </div>
                                        ) : (
                                            <table className="results-table">
                                                <thead>
                                                    <tr>
                                                        <th>Código</th>
                                                        <th>Nome</th>
                                                        <th>Email</th>
                                                        <th>Departamento</th>
                                                        <th>Acções</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list?.map((agente) => (
                                                        <tr
                                                            key={agente.id}
                                                        >
                                                            <td>
                                                                <div className="agent-cell">
                                                                    <EditOutlined className={classNames('agent-avatar', 'agent-avatar-icon',)} />
                                                                    <p className="agent-name">{agente.codigo}</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="agent-cell">
                                                                    <UserOutlined className={classNames('agent-avatar', 'agent-avatar-icon',)} />
                                                                    <p className="agent-name">{agente.name}</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="agent-cell">
                                                                    <MailOutlined className={classNames('agent-avatar', 'agent-avatar-icon',)} />
                                                                    <p className="agent-name">{agente.email}</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="agent-cell">
                                                                    <p className="agent-name">{agente.departamento}</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="agent-cell">
                                                                    <Button
                                                                        icon={agente?.activo == 1 ? <MinusCircleOutlined /> : <CheckCircleOutlined />}
                                                                        size="small"
                                                                        style={{
                                                                            marginBottom: "6px",
                                                                            background: agente?.activo == 1 ? "#ff4d4f" : "#52c41a",
                                                                            borderColor: agente?.activo == 1 ? "#ff4d4f" : "#52c41a",
                                                                            color: "white"
                                                                        }}
                                                                        onClick={() => handleAgenteSelect(agente)}
                                                                    >
                                                                        {
                                                                            agente?.activo == 1 ? "Bloquear" : "Activar"
                                                                        }
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                </div>
                            }
                        </div>,
                    },
                ]}
            />
        </>
    )
}